import { render, staticRenderFns } from "./AverageTransactionModal.vue?vue&type=template&id=0788b579"
import script from "./AverageTransactionModal.vue?vue&type=script&lang=js"
export * from "./AverageTransactionModal.vue?vue&type=script&lang=js"
import style0 from "./AverageTransactionModal.vue?vue&type=style&index=0&id=0788b579&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports